import { Button } from "@mui/material";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";
import { STATUS_CODES } from "constants/responses/statusCodes";
import { useGlobalContext } from "context/GlobalContext";
import React, { useState } from "react";
import { PageTitle } from "components/PageMeta/PageTitle";
import { pageName } from "constants/pageNames";
import { useFinishContext } from "../context";
import { updateFinishApi } from "API/apis/finish/updateFinish";
import { finishOperationsList } from "../constants/finish.constants";
import { FinishTopBanner } from "../components/FinishTopBanner";

const initialState = {
  id: 0,
  approvedBy: "",
  approvedOn: new Date(),
  createdBy: "",
  createdOn: new Date(),
  finishCode: "",
  finishDescription: "",
  isApproved: false,
};
export const UpdateFinish = () => {
  const { setError, setSuccess, setIsLoading } = useGlobalContext();
  const { setCurrentOperationPage, previewFinish, setReloadRequired } =
    useFinishContext();
  const [formData, setFormData] = useState(previewFinish);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleUpdateUserSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const { data, status } = await updateFinishApi({ ...formData });
      if (status !== STATUS_CODES.SUCCESS) {
        throw new Error(data.message);
      }
      setFormData(initialState);
      setReloadRequired(true);
      setSuccess(data?.message);
      setCurrentOperationPage(finishOperationsList.listFinish);
      setIsLoading(false);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };
  return (
    <>
      <PageTitle pageName={pageName.finish.updateFinish} />
      <FinishTopBanner
        buttonType="back"
        finishOperationsParam={finishOperationsList.listFinish}
      />
      <form onSubmit={handleUpdateUserSubmit}>
        <TextFieldWrapper
          id="finishCode"
          name="finishCode"
          label="Finish Code"
          variant="outlined"
          value={formData.finishCode}
          fullWidth
          required
          onChange={handleChange}
        />
        <TextFieldWrapper
          id="finishDescription"
          name="finishDescription"
          label="Finish Description"
          variant="outlined"
          value={formData.finishDescription}
          fullWidth
          required
          onChange={handleChange}
        />
        <Button variant="contained" type="submit" fullWidth>
          Submit
        </Button>
      </form>
    </>
  );
};
